import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      className="design-iconfont"
      width={width}
      height={height}
    >
      <path
        fill={color}
        d="M13.9989042,4.00000882 L14.0000544,3.00000945 L2.00066206,2.98620605 L1.99951172,3.98620605 L13.9989042,4.00000882 Z M13.9994793,8.50000906 L13.9994793,7.50000906 L7.50008678,7.50000906 L7.50008678,8.50000906 L13.9994793,8.50000906 Z M13.9989042,13.0000095 L14.0000544,12.0000095 L2.00066207,11.9862061 L1.99951172,12.9862061 L13.9989042,13.0000095 Z M5.96675348,8.3930769 L2.80008656,10.7680769 C2.47046837,11.0152898 2.00008662,10.7800994 2.00008664,10.3680768 L2.00008685,5.61807632 C2.00008687,5.20605373 2.47046861,4.9708631 2.80008686,5.21807671 L5.96675372,7.59307671 C6.23342037,7.79307699 6.2334199,8.19307661 5.96675348,8.3930769 Z M4.83342004,7.9930768 L3.00008667,9.3680768 L3.00008678,6.61807632 L4.83342004,7.9930768 Z"
        fillOpacity=".89999998"
        fillRule="evenodd"
      />
    </svg>
  )
}
const FontIndentIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default FontIndentIcon
